// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2kl1u","topBottomGutter":"Layout_topBottomGutter__3t6cD"};